import { render, staticRenderFns } from "./ContactField.vue?vue&type=template&id=024f5b74&scoped=true&"
import script from "./ContactField.vue?vue&type=script&lang=js&"
export * from "./ContactField.vue?vue&type=script&lang=js&"
import style0 from "./ContactField.vue?vue&type=style&index=0&id=024f5b74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024f5b74",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormLabel: require('/workspace/components/Form/FormLabel.vue').default})
